<div class="compose-overlay-host">
  <ng-container *ngFor="let panel of visiblePanels; trackBy: trackByPanelId">
    <app-compose-panel
      [panel]="panel"
      (cancel)="onCancel($event)"
      (send)="onSend($event)"
      (deleteDraft)="onDeleteDraft($event)"
      (bringToFront)="onBringToFront($event)"
      (minimize)="onMinimize($event)"
      (positionChanged)="onPositionChanged(panel.id, $event)">
    </app-compose-panel>
  </ng-container>
</div>
